import React from 'react'
import { makeStyles } from "@material-ui/core";
import { useEffect, useState } from "react";
import SVG from "react-inlinesvg";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useHistory } from "react-router-dom";
import { resetCallLogs } from "../../../../app/components/CallLogsFilters";
import * as auth from "../../../../app/modules/Auth/_redux/authRedux";
import ConfigurationSubHeader from "../../../../app/modules/Configuration/pages/ConfigurationSubHeader";
import {
  onPageAndPageSizeChangeEmail,
  onPageAndPageSizeChangeSMS,
  onTabChange,
} from "../../../../app/modules/Configuration/state/slices/templateSlice";
import * as crmConstants from "../../../../app/modules/CRM/constants";
import AgentDetailedBreadCrumbs from "../../../../app/modules/Insights/pages/insights/agent-detailed-view/agent-detailed-breadcrumbs/AgentDetailedBreadCrumbs";
import * as insights from "../../../../app/modules/Insights/_redux/insightsRedux";
import LiveInteractionsSubHeader from "../../../../app/modules/LiveInteractions/pages/LiveInteractionsSubHeader";
import SettingsHeader from "../../../../app/modules/Settings/pages/SettingsHeader";
import { Tracker } from "../../../../app/util/analytics";
import { getCrmCustomerName } from "../../../../app/util/getCustomer";
import * as helpers from "../../../../app/util/helpers";
import { getUser, resetInsightsPage, isDateInRange } from "../../../../app/util/helpers";
import { toAbsoluteUrl } from "../../../_helpers";
import { AnimateLoading } from "../../../_partials/controls";
import { Topbar } from "./Topbar";
import CampaignHeader from '../../../../app/modules/Campaign/pages/CampaignHeader';
import MyAccountHeader from '../../../../app/modules/MyAccount/pages/MyAccountHeader';
import WarningText from '../../../../app/util/WarningText';
import DisclaimerText from '../../../../app/util/DisclaimerText';

const configurationPagePaths = [
  "Phonebooks",
  "Dispositions",
  "Sounds",
  "Reports",
  "Templates",
  "Sticky Agents",
];

const settingsPagePaths = ["Hook API", "Agent Settings", "Queue Settings", "Call Flow", "SMS Flow", "Call Groups", "Integrations"];

const accountPagePaths = [
"Settings",
...(helpers.isFeatureEnabledProfile('international_user') ? [ "Profile" ] : []),
"Invoices",
"Billing Summary",
"History",
"Payments & Plans",
"Bill Statement"];

const campaignPagePaths = ["Create Campaign", "Campaign"];

const useStyles = makeStyles((theme) => ({
  headerLabel: {
    padding: "0 25px",
    height:65
  },
}));
export function Header({ paths, setPsuedoEl }) {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const classes = useStyles();

  const [headertitle, setHeadertitle] = useState("");
  const [nameSearch, setNameSearch] = useState("");
  const [agentList, setAgentList] = useState([]);

  const { extra_data } = useSelector(({ auth }) => ({
    extra_data: auth.extra_data,
  }));

  useEffect(() => {
    setHeadertitle(paths[location.pathname]);
  }, [location.pathname, extra_data]);

  useEffect(() => {
    if (selectedAgent) {
      const payload = {
        first_name__icontains: nameSearch,
        limit: 5,
      };
      dispatch(insights.actions.agentListings(payload));
    }
  }, [nameSearch]);

  // OldSr Iframe Communication channel
  function messageEventHandler(event) {
    if (event.data === 'send_to_obdlogs') {
      history.push('/campaign');
      window.removeEventListener("message", messageEventHandler);
    }
    if (event.data === 'send_to_kycSettings') {
      history.push('/settings');
      window.removeEventListener("message", messageEventHandler);
    }
  }

  useEffect(() => {
    if (!location.pathname.includes("/insights")) {
      dispatch(insights.actions.selectedAgent(null));
    }
    if (!location.pathname.includes("/call-logs")) {
      resetCallLogs(auth, dispatch, true);
    }
    if (!location.pathname.includes("/templates")) {
      dispatch(onPageAndPageSizeChangeSMS({ currentPage: 1, pageSize: 10 }));
      dispatch(onPageAndPageSizeChangeEmail({ currentPage: 1, pageSize: 10 }));
      dispatch(onTabChange(0));
    }
    if (!helpers.isFeatureEnabledProfile('hide_iframe_redirection')) window.addEventListener("message", messageEventHandler);
  }, [location.pathname]);

  const headerContentWrapper = (header) => {
    switch (header) {
      case "Live Interactions":
        return <LiveInteractionsSubHeader />;
      case getActiveSubHeaderName(header):
        return <ConfigurationSubHeader />;
      case getSettingsActiveHeader(header):
        return <SettingsHeader />;
      case getSettingsActiveHeaderCampaign(header):
        return <CampaignHeader />;
      case getSettingsActiveHeaderAccount(header): 
        return <MyAccountHeader />
      default:
        break;
    }
  };

  const getActiveSubHeaderName = (header) => {
    // Tracker.event("Sticky Agent","Click","Sticky Agent Click", "Sticky Agent Tab" , helpers.getUser());
    if (configurationPagePaths.includes(header)) {
      return header;
    }
  };
  const getSettingsActiveHeader = (header) => {
    if (settingsPagePaths.includes(header)) {
      return header;
    }
  };

  const getSettingsActiveHeaderCampaign = (header) => {
    if(campaignPagePaths.includes(header)) {
      return header;
    }
  };

  const getSettingsActiveHeaderAccount = (header) => {
    if(accountPagePaths.includes(header)) {
      return header;
    }
  };

  const selectedAgent = useSelector((state) => {
    return state.insights.selectedAgent ? state.insights.selectedAgent : null;
  });

  const agentListings = useSelector((state) => {
    return state.insights.agentListings ? state.insights.agentListings : null;
  });

  const goBackToInsights = () => {
    dispatch(insights.actions.selectedAgent(null));
    resetInsightsPage(dispatch);
  };

  useEffect(() => {
    if (agentListings) {
      makeAgentListingsForSelect(agentListings);
    }
  }, [agentListings]);

  const makeAgentListingsForSelect = (data) => {
    let agentListingsForSelect = [];
    data.forEach((element) => {
      agentListingsForSelect.push({
        value: element.id,
        label: element.first_name + " " + element.last_name,
      });
    });
    setAgentList([...agentListingsForSelect]);
  };

  const handleAgentChange = (selectedOption) => {
    if (selectedAgent) {
      Tracker.event(
        "Insights",
        "Agent Detailed Insights",
        "Agent Selected",
        selectedOption.value,
        getUser()
      );
    }
    dispatch(
      insights.actions.selectedAgent({
        name: selectedOption.label,
        id: selectedOption.value,
      })
    );
  };

  const handleAgentInputChange = (agent_name) => {
    if (agent_name) {
      setNameSearch(agent_name);
    } else {
      setNameSearch("");
    }
  };

  let currentPath = "others";
  if (headertitle === "Dashboard") {
    currentPath = "dashboard";
  } else if (headertitle === "SMS Logs") {
    currentPath = "smslogs";
  } else if (headertitle === "Call Logs") {
    currentPath = "call-logs";
  } else if (headertitle === "WhatsApp Outbound Logs") {
    currentPath = "whatsapplogs";
  } else if (headertitle === "Live Interactions") {
    currentPath = "Live Interactions";
  } else if (headertitle === "Customer Management") {
    currentPath = "crm";
  }
  if (location.pathname === "/live-interactions/queues-monitor") {
    currentPath = "agent-/live-interactions/queues-monitor";
  }

  const module = helpers.getModule(location);
  if (module === "crm-customer") {
    currentPath = "crm-customer";
  }

  const dateInRange = isDateInRange('2024-03-18 00:00', '2024-03-22 02:30');

  return (
    <>
      <div className="d-none d-lg-block">
        <div className={`header `} id="kt_header">
          <div
            className={`d-flex align-items-stretch ${(currentPath === "others" && !headertitle && !module) ? 'justify-content-end' : 'justify-content-between'} flex-grow-1 ${classes.headerLabel}`}
          >
            {currentPath === "dashboard" && (
              <div className="header-option d-flex align-items-center">
                <span>
                  <img
                    alt=""
                    src={toAbsoluteUrl(
                      "/media/sr/icons/Dashboard-icon-blue.svg"
                    )}
                    className="header-icon"
                  />
                </span>
                <span className="header-label">Dashboard</span>
              </div>
            )}

            {headertitle === "Insights" && (
              <span className="d-flex align-items-center">
                {selectedAgent === null && (
                  <div className="header-option d-flex align-items-center">
                    <span>
                      {!location.pathname.includes("docs") && (
                        <img
                          alt=""
                          src={toAbsoluteUrl(
                            "/media/sr/icons/insights-icon-blue.svg"
                          )}
                          className="header-icon"
                        />
                      )}
                    </span>
                    <span className="header-label">Insights</span>
                  </div>
                )}
                {selectedAgent !== null && (
                  <div className=" d-flex align-items-center">
                    <AgentDetailedBreadCrumbs
                      agentList={agentList}
                      goBackToInsights={goBackToInsights}
                      selectedAgent={selectedAgent}
                      handleAgentChange={handleAgentChange}
                      handleAgentInputChange={handleAgentInputChange}
                    />
                  </div>
                )}
              </span>
            )}

            {currentPath === "crm" && (
              <div className="header-option d-flex align-items-center">
                <span>
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/sr/icons/crm/crm-header-icon.svg"
                    )}
                    style={{ height: 22, width: 22 }}
                  />
                </span>
                <span className="header-label">Customer Management</span>
              </div>
            )}

            {currentPath === "agent-/live-interactions/queues-monitor" && (
              <div className="header-option d-flex align-items-center">
                <span
                  className="header-badge badge badge-secondary"
                  style={{ fontSize: "13px" }}
                >
                  Queues Monitor
                </span>
              </div>
            )}

            {(headertitle === "Live Interactions" ||
              configurationPagePaths.includes(headertitle) ||
              campaignPagePaths.includes(headertitle) ||
              accountPagePaths.includes(headertitle) ||
              settingsPagePaths.includes(headertitle)) &&
              !helpers.isAgent() && (
                <div className="header-option d-flex align-items-center">
                  {headerContentWrapper(headertitle) &&
                    headerContentWrapper(headertitle)}
                </div>
              )}
            {headertitle === "Configuration" && (
              <div className="header-option d-flex align-items-center">
                {headerContentWrapper(headertitle) &&
                  headerContentWrapper(headertitle)}
              </div>
            )}
            {/* {headertitle === "Settings" && (
              <div className="header-option d-flex align-items-center">
                {headerContentWrapper(headertitle) &&
                  headerContentWrapper(headertitle)}
              </div>
            )} */}
            {currentPath === "smslogs" && (
              <div className="header-option d-flex align-items-center">
                {helpers.isFeatureEnabled("call_logs") && (
                  <Link
                    onClick={() => {
                      Tracker.event(
                        "Call Logs",
                        "Click",
                        "Call Logs Tab",
                        "Call Logs Tab Click",
                        helpers.getUser()
                      );
                    }}
                    to="/call-logs"
                  >
                    <span className="header-label ">
                      <span className="header-badgedd badge badge-secondarydd">
                        Call Logs
                      </span>
                    </span>
                  </Link>
                )}
                {helpers.isSMSLogsEnabled() &&
                  helpers.isFeatureEnabled("sms_logs") && (
                    <span className="header-label ">
                      <span
                        className="header-badge badge badge-secondary"
                        onClick={() => {}}
                      >
                        SMS Logs
                      </span>
                    </span>
                  )}
                    {helpers.isFeatureEnabledProfile('is_whatsapp_voice_enabled') &&
                      <Link
                      onClick={() => {
                        Tracker.event(
                          "Call Logs",
                          "Click",
                          "Call Logs Tab",
                          "Call Logs Tab Click",
                          helpers.getUser()
                        );
                      }}
                      to="/whatsapplogs"
                    >
                      <span className="header-label ">
                        <span className="header-badgedd badge badge-secondarydd">
                          WhatsApp Outbound Logs
                        </span>
                      </span>
                    </Link> 
                  }
              
              </div>
            )}
            

            {module === "crm-customer" &&
              helpers.isFeatureEnabled("customer_management") && (
                <div className="header-option d-flex align-items-center">
                  {helpers.isFeatureEnabled("customer_management") && (
                    <Link
                      onClick={() => {
                        Tracker.event(
                          crmConstants.ANALYTICS.VIEW[0],
                          crmConstants.ANALYTICS.VIEW[1],
                          crmConstants.ANALYTICS.VIEW[2],
                          crmConstants.ANALYTICS.VIEW[3],
                          helpers.getUser()
                        );
                      }}
                      to="/customer-management"
                    >
                      <span className="header-label ">
                        <span className="header-badge badge badge-secondary">
                          Customer Management
                        </span>
                      </span>
                    </Link>
                  )}
                  <span>
                    <img
                      alt=""
                      src={toAbsoluteUrl(
                        "/media/sr/icons/header-arrow-icon.svg"
                      )}
                      className="ml-4"
                    />
                  </span>
                  <span className="header-label">
                    <span className="selected-custmoer">
                      {getCrmCustomerName()}
                    </span>
                  </span>
                </div>
              )}

            {currentPath === "call-logs" && (
              <div className="header-option d-flex align-items-center">
                {helpers.isFeatureEnabled("call_logs") && (
                  <Link onClick={() => {}} to="/call-logs">
                    <span className="header-label ">
                      <span className="header-badge badge badge-secondary">
                        Call Logs
                      </span>
                    </span>
                  </Link>
                )}
                {helpers.isSMSLogsEnabled() &&
                  helpers.isFeatureEnabled("sms_logs") && (
                    <Link
                      onClick={() => {
                        Tracker.event(
                          "SMS Logs",
                          "Click",
                          "SMS Logs Tab",
                          "SMS Logs Tab Click",
                          helpers.getUser()
                        );
                      }}
                      to="/smslogs"
                    >
                      <span className="header-label ">
                        <span className="header-badgedd badge badge-secondarydd">
                          SMS Logs
                        </span>
                      </span>
                    </Link>
                  )}
                   {helpers.isFeatureEnabledProfile('is_whatsapp_voice_enabled') &&
                       <Link
                      onClick={() => {
                        
                      }}
                      to="/whatsapplogs"
                    >
                      <span className="header-label ">
                        <span className="header-badgedd badge badge-secondarydd">
                          WhatsApp Outbound Logs
                        </span>
                      </span>
                    </Link>
                  }
              </div>
            )}
               {currentPath === "whatsapplogs" && (
              <div className="header-option d-flex align-items-center">
                {helpers.isFeatureEnabled("call_logs") && (
                    <Link
                    onClick={() => {
                      Tracker.event(
                        "Call Logs",
                        "Click",
                        "Call Logs Tab",
                        "Call Logs Tab Click",
                        helpers.getUser()
                      );
                    }}
                    to="/call-logs"
                  >
                    <span className="header-label ">
                      <span className="header-badgedd badge badge-secondarydd">
                        Call Logs
                      </span>
                    </span>
                  </Link>
                )}
                {helpers.isSMSLogsEnabled() &&
                  helpers.isFeatureEnabled("sms_logs") && (
                    <Link
                      onClick={() => {
                        Tracker.event(
                          "SMS Logs",
                          "Click",
                          "SMS Logs Tab",
                          "SMS Logs Tab Click",
                          helpers.getUser()
                        );
                      }}
                      to="/smslogs"
                    >
                      <span className="header-label ">
                        <span className="header-badgedd badge badge-secondarydd">
                          SMS Logs
                        </span>
                      </span>
                    </Link>
                  )}
                   {helpers.isFeatureEnabledProfile('is_whatsapp_voice_enabled') &&
                      <Link onClick={() => {}} to="/whatsapplogs">
                    <span className="header-label ">
                      <span className="header-badge badge badge-secondary">
                        WhatsApp Outbound Logs
                      </span>
                    </span>
                  </Link>
                    }
              </div>
            )}

            <AnimateLoading />
            <Topbar setPsuedoEl={setPsuedoEl} />
          </div>
          <div style={{ position: 'relative', overflow: 'hidden' }}>
          {['/home', '/call-logs'].some(path => location.pathname.includes(path)) && dateInRange && <DisclaimerText
                className="warning-slide3"
                message="As part of a planned maintenance activity, New Call Logs will not be visible from 21st March 11.30 PM to 22nd March 2.30 AM. Rest assured no data loss will occur."
            />}
            {['/insights', '/dashboard', '/call-logs', '/smslogs'].some(path => location.pathname.includes(path)) ? (
              <WarningText
                className="warning-slide1"
                message={helpers.isCountryIndia() 
                  ? "<b>New Product:</b> Whatsapp Voice Calling is now LIVE. If you are interested to enable Whatsapp Voice, reach out to us on <a target='_balnk' href='https://wa.me/call/91865772185'>https://wa.me/call/918657721850</a>" 
                  : "<b>New Product:</b> Whatsapp Voice Calling is now LIVE. If you are interested to enable Whatsapp Voice, reach out to us on <a target='_balnk' href='https://wa.me/call/91865772185'>https://wa.me/call/918657721850</a>" 
                }
              />
            ) : (
              <WarningText
                className="warning-slide2"
                message={helpers.isCountryIndia() 
                  ? "<b>New Product:</b> Whatsapp Voice Calling is now LIVE. If you are interested to enable Whatsapp Voice, reach out to us on <a target='_balnk' href='https://wa.me/call/91865772185'>https://wa.me/call/918657721850</a>" 
                  :"<b>New Product:</b> Whatsapp Voice Calling is now LIVE. If you are interested to enable Whatsapp Voice, reach out to us on <a target='_balnk' href='https://wa.me/call/91865772185'>https://wa.me/call/918657721850</a>" 
                }
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
